module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/blog-search-d314f25c3f6587325d78d61d853cd961.jpg";